// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/transportation/transportation.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_common } from "../../core/common_pb";
import { file_proto_model_core_provider } from "../../core/provider_pb";
import { file_proto_model_feature_transportation_flight } from "./flight_pb";
import { file_proto_model_financial_invoice } from "../../financial/invoice_pb";

/**
 * Describes the file proto/model/feature/transportation/transportation.proto.
 */
export const file_proto_model_feature_transportation_transportation = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_duration, file_google_protobuf_timestamp, file_proto_model_core_common, file_proto_model_core_provider, file_proto_model_feature_transportation_flight, file_proto_model_financial_invoice]);

/**
 * Describes the message carmen.Itinerary.
 * Use `create(ItinerarySchema)` to create a new message.
 */
export const ItinerarySchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_transportation, 0);

/**
 * Describes the message carmen.Journey.
 * Use `create(JourneySchema)` to create a new message.
 */
export const JourneySchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_transportation, 1);

/**
 * Describes the message carmen.JourneyBookingInfo.
 * Use `create(JourneyBookingInfoSchema)` to create a new message.
 */
export const JourneyBookingInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_transportation, 2);

/**
 * Describes the message carmen.Segment.
 * Use `create(SegmentSchema)` to create a new message.
 */
export const SegmentSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_transportation, 3);

/**
 * Describes the message carmen.TravelLocation.
 * Use `create(TravelLocationSchema)` to create a new message.
 */
export const TravelLocationSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_transportation, 4);

/**
 * Describes the message carmen.Stop.
 * Use `create(StopSchema)` to create a new message.
 */
export const StopSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_transportation, 5);

/**
 * Describes the message carmen.TravelerPricing.
 * Use `create(TravelerPricingSchema)` to create a new message.
 */
export const TravelerPricingSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_transportation, 6);

/**
 * Describes the message carmen.BaggageAllowance.
 * Use `create(BaggageAllowanceSchema)` to create a new message.
 */
export const BaggageAllowanceSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_transportation, 7);

/**
 * Describes the enum carmen.TicketType.
 */
export const TicketTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_transportation_transportation, 0);

/**
 * TicketType specifies the type of an itinerary, e.g., one-way or round-trip.
 *
 * @generated from enum carmen.TicketType
 */
export const TicketType = /*@__PURE__*/
  tsEnum(TicketTypeSchema);

/**
 * Describes the enum carmen.JourneyStatus.
 */
export const JourneyStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_transportation_transportation, 1);

/**
 * JourneyStatus represents the operational status of a journey.
 *
 * @generated from enum carmen.JourneyStatus
 */
export const JourneyStatus = /*@__PURE__*/
  tsEnum(JourneyStatusSchema);

